import React from "react";
import classes from "../styles/style.module.css";
import getProfileImage from "../../../assets/Hooks/getProfileImage";

const UserAvatar = ({ userAvatar, userName, handleClick }) => {
  return (
    <div className={classes.userAvatarContainer} onClick={handleClick}>
      {getProfileImage(userAvatar)}
      <div className={classes.titleContainer}>
        <p>سلام {userName}</p>
        <p>به  سامانه ارتباطات فرهنگی راه بهشت خوش آمدید 👋</p>
      </div>
    </div>
  );
};

export default UserAvatar;
